export enum AnalyticsEvents {
  FEATURE_INIT = 'feature_init',
  FEATURE_FINISHED = 'feature_finished',
  USER_PREFER_WAIT = 'user_prefer_wait',
  SIGNUP_EMAIL = 'signup_email',
  SIGNUP_PERSONAL_DATA = 'signup_personal_data',
  SIGNUP_PASSWORD = 'signup_password',
  SIGNUP_PHONE_CLICK = 'signup_phone_click',
  DOWNLOAD_APP = 'download_app',
  PICK_UP_PACKAGE = 'pick_up_package',
  PICK_UP_CALL_AGENT = 'pick_up_call_agent',
  TRANSACTION_CREATED_SUCCESS = 'transaction_created_success',
  TRANSACTION_CREATED_FAIL = 'transaction_created_fail',
  TRANSACTION_ERROR_SCREEN = 'transaction_error_screen',
  TRANSACTION_FINISHED_48HS = 'transaction_finished_48hs',
  TRANSACTION_ERROR_SCREEN_PHONE = 'transaction_error_screen_phone',
  TRANSACTION_ERROR_SCREEN_EMAIL = 'transaction_error_screen_email',
  TRANSACTION_FINISHED_SCREEN_PHONE = 'transaction_finished_screen_phone',
  TRANSACTION_FINISHED_SCREEN_EMAIL = 'transaction_finished_screen_email',
  TRANSACTION_RETRIEVED = 'transaction_retrieved',
  TRANSACTION_TRACKING_NOT_FOUND = 'transaction_tracking_not_found',
  LOCATION_CONTROL_LETTER_CONFIRM = 'location_control_letter_confirm',
  LOCATION_CONTROL_LETTER_AGENT = 'location_control_letter_agent',
  LOCATION_CONTROL_LETTER_SUCCESS = 'location_control_letter_success',
  LOCATION_CONTROL_LETTER_ERROR = 'location_control_letter_error',
  LOCATION_OPENING_CODE_REUSED = 'location_opening_code_reused',
  LOCATION_CONTROL_LETTER_OPEN_INCIDENT = 'location_control_letter_open_incident',
  OPENING_FAIL = 'opening_fail',
  OPENING_AUTOFIX = 'opening_autofix',
  OPENING_SUCCESS = 'opening_success',
  USER_SIGNUP_VIEW = 'user_signup_view',
  USER_SIGNUP_START = 'user_signup_start',
  USER_SIGNUP_BENEFITS_OPEN = 'user_signup_benefits_open',
  USER_SIGNUP_BENEFITS_CONFIRM = 'user_signup_benefits_confirm',
  USER_SIGNUP_SUCCESS = 'user_signup_success',
  USER_SIGNUP_FAIL = 'user_signup_fail',
  USER_DELETE_ACCOUNT = 'user_delete_account',
  USER_DELETE_ACCOUNT_FAIL = 'user_delete_account_fail',
  USER_TRY_CITIBOX = 'user_try_citibox',
  USER_OPTOUT_CONTINUE = 'user_optout_continue',
  USER_OPTOUT_SIGNUP = 'user_optout_signup',
  USER_REOPEN_BOX = 'user_reopen_box',
  USER_REOPEN_BOX_SUCCESSFUL = 'user_reopen_box_successful',
  USER_REOPEN_BOX_FAIL = 'user_reopen_box_fail',
  ACCESS_USAGE_START_VALIDATION = 'access_usage_start_validation',
  ACCESS_USAGE_VALIDATED = 'access_usage_validated',
  ACCESS_USAGE_DENIED = 'access_usage_denied',
  USER_TAPED_CALL_AGENT = 'user_taped_call_agent',
  USER_TAPED_START_AGAIN = 'user_taped_start_again',
  OPENING_CONFIRMED = 'opening_confirmed',
  SHOW_CODE_SCREEN_VIEW = 'show_code_screen_view',
  SHOW_OPEN_CODE = 'show_open_code',
  OPEN_CODE_SHOWED = 'open_code_showed',
  OPEN_CODE_SHOWED_FAILED = 'open_code_showed_failed',
  DROP_OFF_FEATURE_ALLOWED = 'drop_off_feature_allowed',
  DELIVERY_CHECK_DELIVERABLE = 'delivery_check_deliverable',
  DELIVERY_CREATED = 'delivery_created',
  DELIVERY_CREATED_FAIL = 'delivery_created_fail',
  USER_TAPPED_START = 'user_tapped_start',
  DROPOFF_STARTED = 'dropoff_started',
  DROPOFF_CHECK_CONTINUABLE = 'dropoff_check_continuable',
  DROPOFF_CONTINUED = 'dropoff_continued',
  DROPOFF_NOT_STARTED = 'dropoff_not_started',
  DROPOFF_ERROR_CONFIRM = 'dropoff_error_confirm',
  DROPOFF_BACK_CANCEL_BUTTON = 'dropoff_back_cancel_button',
  DROPOFF_TRY_OTHER_CODE = 'dropoff_try_other_code',
  DROP_OFF_CHECK_LABEL_CODE_INITIAL_STEP = 'dropoff_check_label_code_initial_step',
  DROP_OFF_CHECK_LABEL_CODE_SUCCESS_STEP = 'dropoff_check_label_code_success_step',
  DROP_OFF_CHECK_LABEL_CODE_ERROR_STEP = 'dropoff_check_label_code_error_step',
  RETRIEVAL_STARTED = 'retrieval_started',
  RETRIEVAL_NOT_STARTED = 'retrieval_not_started',
  RETRIEVAL_BOX_VALID = 'retrieval_box_valid',
  RETRIEVAL_BOX_NOT_VALID = 'retrieval_box_not_valid',
  RETRIEVAL_NOT_VERIFIED_WITH_TOKEN = 'retrieval_not_verified_with_token',
  RETRIEVAL_ERROR_CONFIRM = 'retrieval_error_confirm',
  RETRIEVAL_SUCCESS = 'retrieval_success',
  RETRIEVAL_FAILED = 'retrieval_failed',
  RETRIEVAL_FEATURE_ALLOWED = 'retrieval_feature_allowed',
  RETRIEVAL_GET_TRACKING_ERROR = 'retrieval_get_tracking_error',
  RETRIEVAL_BACK_CANCEL_BUTTON = 'retrieval_back_cancel_button',
  RETRIEVAL_TAPPED = 'retrieval_tapped',
  RETRIEVAL_CONFIRM_DISMISSED = 'retrieval_confirm_dismissed',
  RETRIEVAL_CONFIRMED = 'retrieval_confirmed',
  CAN_NOT_RETRIEVED_TAPPED = 'can_not_retrieved_tapped',
  BOX_ASSIGNED = 'box_assigned',
  BOX_NOT_ASSIGNED = 'box_not_assigned',
  BOX_NOT_ASSIGNED_WITH_TOKEN = 'box_not_assigned_with_token',
  DELIVER_TAPPED = 'deliver_tapped',
  CAN_NOT_DELIVER_TAPPED = 'can_not_deliver_tapped',
  CHANGE_BOX_SIZE_TAPPED = 'change_box_size_tapped',
  ASSIGN_OTHER_BOX_TAPPED = 'assign_other_box_tapped',
  NEW_CODE_TAPPED = 'new_code_tapped',
  OPEN_AGAIN_TAPPED = 'open_again_tapped',
  CANCEL_TAPPED = 'cancel_tapped',
  EMPTY_BOX_TAPPED = 'empty_box_tapped',
  DROPOFF_CONFIRMED = 'dropoff_confirmed',
  DROPOFF_CONFIRM_DISMISSED = 'dropoff_confirm_dismissed',
  DELIVERY_SUCCESS = 'delivery_success',
  DELIVERY_FAILED = 'delivery_failed',
  DELIVERY_CANCELLED = 'delivery_cancelled',
  FINISH_SUCCESS_BACK_TO_LANDING = 'finish_success_back_to_landing',
  CHANGE_SIZE_NO_BOXES = 'change_size_no_boxes',
  CHANGE_SIZE_FREE_BOXES = 'change_size_free_boxes',
  DROP_OFF_LANDING_OPEN = 'drop_off_landing_open',
  USERS_WEBAPP_SERVICE_RATING = 'users_webapp_service_rating',
  DELIVERY_CANCEL_CONFIRM = 'delivery_cancel_confirm',
  RETRIEVAL_CANCEL_CONFIRM = 'retrieval_cancel_confirm',
  CANCEL_DELIVERY_OPENED_LOCK = 'cancel_delivery_opened_lock',
  CANCEL_DELIVERY_NOT_OPENED_LOCK = 'cancel_delivery_not_opened_lock',
  CANCEL_RETRIEVAL_OPENED_LOCK = 'cancel_retrieval_opened_lock',
  CANCEL_RETRIEVAL_NOT_OPENED_LOCK = 'cancel_retrieval_not_opened_lock',
  CUSTOMER_CARE_PHONE = 'customer_care_phone',
  CUSTOMER_CARE_MAIL = 'customer_care_email',
  DROPOFF_CANCEL_TRASH_BUTTON = 'dropoff_cancel_trash_button',
  RETRIEVAL_CANCEL_TRASH_BUTTON = 'retrieval_cancel_trash_button',
  USER_REJECTED_CAMERA_PERMISSIONS = 'user_rejected_camera_permissions',
  LABEL_CODE_SCREEN_CLOSED = 'label_code_screen_closed',
  LABEL_CODE_CANCEL_CONFIRMED = 'label_code_cancel_confirmed',
  LABEL_CODE_CANCEL_CANCELED = 'label_code_cancel_canceled',
  USER_TAPPED_BACK_TO_CAMERA = 'user_tapped_back_to_camera',
  USER_TAPPED_TO_ENTER_LABEL = 'user_tapped_to_enter_label',
  QR_SCAN_SUCCESS = 'qr_scan_success',
  ACCESS_OPEN_START_CONNECT = 'access_open_start_connect',
  ACCESS_OPEN_CONNECTED = 'access_open_connected',
  ACCESS_OPEN_SUCCESS = 'access_open_success',
  COLLECTION_AUTOFIX_OPTION = 'collection_autofix_option',
  OPEN_BLE_BOX_PROCESS_EVENT = 'open_ble_box_process_event',
  OPEN_BLE_BOX_STATE_EVENT = 'open_ble_box_state_event',
  REOPEN_FROM_DELIVERY_CANCELLATION = 'reopen_from_delivery_cancellation',
  START_BENCHMARK = 'start_benchmark',
  END_BENCHMARK = 'end_benchmark',
  PAGE_RENDERED = 'page_rendered',
  BACK_NAVIGATION = 'back_navigation',
  BACK_NAVIGATION_FORCED = 'back_navigation_forced',
  NAVIGATOR_OFFLINE = 'navigator_offline',
  INVALID_REQUIRED_INPUTS = 'invalid_required_inputs',
  // 39 of GA4's 40-character event-name limit once sendEvent prepends 'c_webapp_'. A longer name
  // here is silently dropped by GA4, not truncated.
  BUTTON_DUPLICATE_CLICK_IGNORED = 'button_duplicate_click_ignored'
}
